import React, { useReducer } from 'react'
import { PutAwayContext } from '../Context/usePutAway'
import { putAwayReducer, initialState } from '../reducer/putAwayReducer'

export const PutAwayProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(putAwayReducer, initialState)

  const value = { state, dispatch }
  return (
    <PutAwayContext.Provider value={value}>{children}</PutAwayContext.Provider>
  )
}
